import React from 'react'
import Icons from '../Icons'

export default function Alert({
    type,
    className,
    style,
    header = '',
    topContent = '',
    content = '',
    cta = '',
    onDismiss,
    children,
    hideIcon = false
}) {
    let classes = 'alert alert_' + type
    if (className) classes += ' ' + className
    let icon = ''
    if (type === 'success') icon = 'tickCircle'
    if (type === 'warning') icon = 'warning'
    if (type === 'error') icon = 'warning'
    if (type === 'info') icon = 'info'
    return (
        <div className={classes} style={style}>
            {!!onDismiss && (
                <div className='alert_dismiss'>
                    <Icons icon='cross' color={'var(--neutral-950)'} onClick={onDismiss} />
                </div>
            )}
            {!hideIcon && <Icons className='icon' icon={icon} style={{ width: 20, height: 20 }} />}
            <div style={{ flexGrow: 1 }}>
                {topContent}
                {!!header && <div className='text-heavy mar-b5'>{header}</div>}
                <div style={{ fontSize: 13 }}>{!!content ? content : children}</div>
                {!!cta && <div className='mar-t10'>{cta}</div>}
            </div>
        </div>
    )
}
